import React, { useEffect, useState } from 'react';
import { apiGetCategory } from '@services/ManageDevices/DeviceServices';
import { Select } from 'antd';

const mapListToOptions = (data) => {
  return data?.map((item) => ({
    value: item.value,
    label: item.name,
    ...item
  }));
};

export const SelectRoute = ({ disabled = false, onChange, value, parentZone, parentDevice }) => {
  const [options, setOptions] = useState([]);

  const handleChange = (value) => {
    onChange && onChange(value);
  };

  const fetchOptions = async (valueSearch) => {
    const response = await apiGetCategory({
      keyword: valueSearch === '' ? undefined : valueSearch,
      type: 'TUYEN',
      parent_level_1_id: parentDevice ?? undefined,
      parent_level_2_id: parentZone ?? undefined
    });
    setOptions([...mapListToOptions(response?.data?.data)]);
  };

  useEffect(() => {
    fetchOptions();
  }, [parentDevice, parentZone]);

  const selected = options.find(({ value: itemValue }) => value === itemValue);

  return (
    <Select
      style={{ width: '100%', height: '36px' }}
      className="w-full"
      cacheOptions
      isDisabled={disabled}
      options={options}
      placeholder="Chọn tuyến"
      loadOptions={fetchOptions}
      value={selected}
      onChange={handleChange}
    />
  );
};
